var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "questions" },
    [
      _c(
        "div",
        { staticClass: "title" },
        [
          _c("h2", { staticClass: "acenter" }, [
            _vm._v(_vm._s(_vm.$l10n.__("Des questions ?")))
          ]),
          _vm._v(" "),
          _c("Underline", { staticClass: "underline-svg" })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-collapse",
        _vm._l(_vm.questions, function(question) {
          return _c(
            "el-collapse-item",
            { key: question.title, attrs: { title: question.title } },
            [_c("div", { domProps: { innerHTML: _vm._s(question.text) } })]
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }